/* eslint-disable react-hooks/exhaustive-deps */
//

import { ImageContent, LANDING_TYPE_CONTENT, PassageSyncContent, } from "src/modules/pe-landing-module/data/interfaces"
import useComponentData from "src/modules/pe-landing-module/hooks/useComponentData"
import { IPrimitiveProps } from "../../section/Primitive"
import ImagePrimitive from "../ImagePrimitive"
import { useEffect } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import useColumnsCount from "src/modules/pe-landing-module/hooks/useColumnsCount"
import PassageImageContainer from "./PassageImageContainer"
import PassageItemEditForm from "../../landing-edit/editors/passage/PassageItemEditForm"

/* Protopia Ecosystem component */  
const MasonryPassagePrimitive = (props: IPrimitiveProps): JSX.Element => {  
    const primitive: PassageSyncContent  = useComponentData<PassageSyncContent>(( props.primitive || {dimensions: {}} ) as PassageSyncContent )    
    const items: ImageContent[] = primitive.items 
    const columns = useColumnsCount(primitive.columns)
    useEffect(() => {
        addCSSClass(
            `landing-passage-${ primitive.id }`,
            `.landing-passage-${ primitive.id } {
                margin-left: -${ primitive.gap * 2 }px;
                margin-right: -${ primitive.gap * 2 }px;
                width: auto!important;
                .passage-container {
                    width: 100%;
                    display: flex;
                    justify-content: center;
                    flex-wrap: wrap;
                    flex-direction: row !important;
                    gap:${ primitive.gap }px;
                    columns: ${ columns };
                }
            }
            .landing-passage-column-${ primitive.id } {
                width: calc(${ Math.floor(100 / columns) }% - ${ primitive.gap * 1 }px); 
            }`
        )
        return () => {
            removeCSSClass( `landing-passage-${ primitive.id }` )
        }
    }, [ columns ])

    if(!primitive.items?.length) return <></>

    return !!items.length
        ?
        <div 
            className={`pe-primitive-container landing-passage-primitive landing-passage-${primitive.id} ${primitive.className || ""} align-items-start`}
            data-primitive-type={ primitive[ "data-primitive-type" ] } 
        >  
            <div className="passage-container d-flex flex-wrap"> 
            {
                Array(columns).fill(0).map(( _, ii ) => {
                    return <div 
                        key={ ii } 
                        className={ `landing-passage-column-${primitive.id}` }
                    >
                    {
                        items
                            .map(( item: any, i ) => ({...item, order:i}))
                            .filter(( _: any, i ) => i % columns === ii )
                            .map(( item: any, i ) => { 
                                const width  = `100%`
                                const height = "auto" 
                                const _primitive : ImageContent = { 
                                    ...item, 
                                    data: {
                                        ...item,
                                        hover_size: primitive.hover_size,
                                        src_type: primitive.src_type || "div",
                                    },
                                    position: {
                                        width,
                                        height,
                                    },
                                    border: primitive.border,
                                    type: LANDING_TYPE_CONTENT.IMAGE,
                                    className: `${ item.className || "" } ${ primitive.className || "" }`, 
                                    style: { ...primitive.style, marginBottom: primitive.gap },
                                }
                                return <PassageImageContainer 
                                    key={ item.id } 
                                    width={ width } 
                                    height={ height } 
                                    i={ item.order } 
                                    animated={ primitive.animated }  
                                    animated_delay={ primitive.animated_delay }
                                >
                                    <PassageItemEditForm i={ item.order } primitive={ _primitive } items={ items }  >
                                        <ImagePrimitive 
                                            i={ item.order }
                                            primitive={ _primitive as ImageContent }
                                        />
                                    </PassageItemEditForm>
                                </PassageImageContainer>
                            })
                    }
                    </div> 
                })
            }
            </div>
        </div>
        :
        <></>
}

export default MasonryPassagePrimitive